import { atom, useAtom } from "jotai";

export const comboActiveInstrumentIdAtom = atom<string>("");

export const useComboActiveInstrumentId = () => {
  const [comboActiveInstrumentId, setComboActiveInstrumentId] = useAtom(
    comboActiveInstrumentIdAtom,
  );

  return {
    comboActiveInstrumentId,
    setComboActiveInstrumentId,
  };
};
